import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onEnter", "onKeyDown"];
import React, { forwardRef } from 'react';
function withEnterKeyHandler(WrappedComponent) {
  // The resulting component's props include the wrapped component's props,
  // plus an optional `onEnter` callback.

  var WithEnterKeyHandler = /*#__PURE__*/forwardRef(function (props, ref) {
    var onEnter = props.onEnter,
      _onKeyDown = props.onKeyDown,
      rest = _objectWithoutProperties(props, _excluded);

    // Handler for the keydown event: if the key is Enter, call onEnter.
    var handleKeyDown = function handleKeyDown(event) {
      if (event.key === 'Enter') {
        onEnter === null || onEnter === void 0 || onEnter();
      }
    };
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, rest, {
      onKeyDown: function onKeyDown(event) {
        handleKeyDown(event);
        _onKeyDown === null || _onKeyDown === void 0 || _onKeyDown(event);
      },
      ref: ref,
      "data-t-id": "utils-withOnEnterKeyHandler"
    }));
  });

  // Set a descriptive display name for React DevTools.
  var displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  WithEnterKeyHandler.displayName = "withEnterKeyHandler(".concat(displayName, ")");
  return WithEnterKeyHandler;
}
export default withEnterKeyHandler;